
;(function($, window) {

  // helpers
  var wait = (function() {
    var intrvl = {};
    var removeListener = function(sel) {
      if (intrvl[sel]) {
        window.clearInterval(intrvl[sel]);
        intrvl[sel] = null;
      }
    };
    var f = 'waiting.f';
    $.fn.waiting = function(handler, run, child) {
      var selector = this.selector;
      var $this = $(selector);
      var $elements = $this.not(function() { return $(this).data(f); });
      if (handler === 'remove') {
        removeListener(selector);
      }
      else {
        $elements.each(handler).data(f, true);
        if (run && $this.length) {
          removeListener(selector);
        }
        else if (!child) {
          intrvl[selector] = window.setInterval(function () {
            $this.waiting(handler, run, true);
          }, 500);
        }
      }
      return $this;
    };
  })();

  // option selectors for quick view
  Shopify.optionsMapQ = {};
  Shopify.updateOptionsInSelectorQ = function(selectorIndex) {
    var sos = $('.qv-select .single-option-selector');
    switch (selectorIndex) {
      case 0:
        var key = 'root';
        var selector = sos.eq(0);
        break;
      case 1:
        var key = sos.eq(0).val();
        var selector = sos.eq(1);
        break;
      case 2:
        var key = sos.eq(0).val();  
        key += ' / ' + sos.eq(1).val();
        var selector = sos.eq(2);
    }
    
    var initialValue = selector.val();
    selector.empty();    
    var availableOptions = Shopify.optionsMapQ[key];
    for (var i=0; i<availableOptions.length; i++) {
      var option = availableOptions[i];
      var newOption = $('<option></option>').val(option).html(option);
      selector.append(newOption);
    }
    $('.qv-select .swatch-qv[data-option-index="' + selectorIndex + '"] .swatch-qv-element').each(function() {
      var t = $(this);
      if ($.inArray(t.attr('data-value'), availableOptions) !== -1) {
        t.removeClass('soldout').show().find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
      }
      else {
        t.addClass('soldout').hide().find(':radio').removeAttr('checked').attr('disabled','disabled');
      }
    });
    if ($.inArray(initialValue, availableOptions) !== -1) {
      selector.val(initialValue);
    }
    selector.trigger('change');  
    
  };
  Shopify.linkOptionSelectorsQ = function(product) {
    // Building our mapping object.
    for (var i=0; i<product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.available) {
        // Gathering values for the 1st drop-down.
        Shopify.optionsMapQ['root'] = Shopify.optionsMapQ['root'] || [];
        Shopify.optionsMapQ['root'].push(variant.option1);
        Shopify.optionsMapQ['root'] = Shopify.uniq(Shopify.optionsMapQ['root']);
        // Gathering values for the 2nd drop-down.
        if (product.options.length > 1) {
          var key = variant.option1;
          Shopify.optionsMapQ[key] = Shopify.optionsMapQ[key] || [];
          Shopify.optionsMapQ[key].push(variant.option2);
          Shopify.optionsMapQ[key] = Shopify.uniq(Shopify.optionsMapQ[key]);
        }
        // Gathering values for the 3rd drop-down.
        if (product.options.length === 3) {
          var key = variant.option1 + ' / ' + variant.option2;
          Shopify.optionsMapQ[key] = Shopify.optionsMapQ[key] || [];
          Shopify.optionsMapQ[key].push(variant.option3);
          Shopify.optionsMapQ[key] = Shopify.uniq(Shopify.optionsMapQ[key]);
        }
      }
    }
    // Update options right away.
    Shopify.updateOptionsInSelectorQ(0);
    if (product.options.length > 1) Shopify.updateOptionsInSelectorQ(1);
    if (product.options.length === 3) Shopify.updateOptionsInSelectorQ(2);
    // When there is an update in the first dropdown.
    $(".qv-select .single-option-selector:eq(0)").change(function() {
      Shopify.updateOptionsInSelectorQ(1);
      if (product.options.length === 3) Shopify.updateOptionsInSelectorQ(2);
      return true;
    });
    // When there is an update in the second dropdown.
    $(".qv-select .single-option-selector:eq(1)").change(function() {
      if (product.options.length === 3) Shopify.updateOptionsInSelectorQ(2);
      return true;
    });
    
  };

  function emQuick($scope, templ) {
    this.$scope = $scope;
    this.templ = templ;
    this.init();
  }

  emQuick.prototype = {
    init: function() {
      var self = this;
      self.qvClose = document.getElementById('qvClose');
      self.wrap = document.getElementById('qvWrap');
      self.theBody = document.getElementById('theBody')

      self.title = self.templ.querySelector('.qv-title');
      self.imgFeatured = self.templ.querySelector('.qv-images-featured');
      self.imgThumb = self.templ.querySelector('.qv-images-thumb');
      self.details = self.templ.querySelector('.qv-details');
      self.vendor = self.templ.querySelector('.qv-details_vendor');
      // self.desc = self.templ.querySelector('.qv-details_desc');
      self.vari = self.templ.querySelector('.qv-details_variants');
      self.variForm = self.templ.querySelector('.qv-details_variants > form');
      self.select = self.templ.querySelector('.qv-select');
      self.priceNormal = self.templ.querySelector('.qv-price > .normal');
      self.priceCompare = self.templ.querySelector('.qv-price > .compare');
      self.priceDiscount = self.templ.querySelector('.qv-price > .discount');
      self.stock = self.templ.querySelector('.qv-stock span');
      self.quant = self.templ.querySelector('.qv-quantity');
      self.priceTot = self.templ.querySelector('.qv-price-total');
      self.addCart = self.templ.querySelector('.qv-add-cart');
      self.addCartBut = self.templ.querySelector('.qv-add-cart_button');
      self.more = self.templ.querySelector('.qv-more');
      self.addCartStatus = self.templ.querySelector('.qv-add-cart_status');
      self.toucheDev = Modernizr.touchevents;

      $('#qvTitle > a ').waiting(function(idx, el) {
        var wrap = document.getElementById('qvWrap');
        wrap.setAttribute('data-wait', '0')
      })
      self.events();
      self.closeView();
    },
    events: function() {
      var self = this;
      self.$scope.on('click', '.card-quickview-trigger', function(ev) {
        ev.stopPropagation();
        ev.preventDefault();

        // close other nav open
        if (jsGlobal.navExpand || jsGlobal.searchExpand) {
          var ids =  ['#hsContent', '#huTarget', '#hcTarget'];
          var n = document.querySelectorAll(ids);
          var nav = Array.prototype.slice.call(n);
          nav.forEach(function(el, idx) {
            el.setAttribute('data-expand', '0');
            jsGlobal.navExpand = false;
            jsGlobal.searchExpand = false;
          })
        }

        self.templ.setAttribute('data-expand', '1');
        self.theBody.setAttribute('data-qvopen', '1');
        self.wrap.setAttribute('data-wait', '2')

        var handle = this.getAttribute('data-handle');
        Shopify.getProduct(handle, function(prod) {

          // variables
          var pId = prod.id;
          var pVari = prod.variants;
          var varLen = prod.variants.length;
          var pOpt = prod.options;
          var pOptLen = prod.options.length;
          var pAvailable = prod.available;
          var pFeatImg = prod.featured_image;
          var pTitle = prod.title;
          var pImgs = prod.images;
          var pImgsLen = prod.images.length;
          var pUrl = prod.url;
          var pVen = prod.vendor;
          var pPrice = prod.price;
          var pCom = prod.compare_at_price;
          var pComMax = prod.compare_at_price_max;


          // featured image
          var c = document.createElement('img');
          var d = Shopify.resizeImage(pFeatImg, 'large');
          // var dd = Shopify.resizeImage(pFeatImg, 'large');
          c.setAttribute('src', d);
          c.setAttribute('id', 'qvImage');
          // c.setAttribute('data-magnify-src', dd);
          c.setAttribute('alt', pTitle);
          self.imgFeatured.appendChild(c);
          self.imgFeatured.setAttribute('data-load', '1')

          // thumbnail
          if (pImgsLen > 1) {
            for (i in pImgs) {
              var e =  document.createElement('img');
              var f = document.createElement('li');
              var thumbs = Shopify.resizeImage(pImgs[i], 'small');
              var thumbsLarge = Shopify.resizeImage(pImgs[i], 'large');
              var ee = parseInt(i, 10);
              var eee = ee+1;
              e.setAttribute('src', thumbs);
              f.setAttribute('data-src', thumbsLarge);
              f.setAttribute('data-pos', eee);
              f.setAttribute('data-selected', '0');
              f.appendChild(e)
              self.imgThumb.appendChild(f);
            }
            setTimeout(function() {
              self.thumbsEvent()
            }, 3000)
          }

          // title
          var a = document.createElement('h5');
          a.setAttribute('class', 'product-title')
          var b = document.createElement('a');
          a.textContent = pTitle;
          b.setAttribute('href', pUrl);
          b.appendChild(a);
          self.title.appendChild(b)

          // details vendor
          var g = document.createElement('a');
          g.setAttribute('class', 'meta-text-light')
          g.setAttribute('href', window.location.protocol + '//' + window.location.hostname + '/collections/vendors?q=' + pVen)
          g.textContent = pVen;
          self.vendor.appendChild(g);

          // details desc
          // var h = document.createElement('p');
          // var texting = prod.description.replace(/(<([^>]+)>)/ig, "");
          // texting.substr(0, 120) + '&hellip;';
          // h.textContent = texting;
          // self.desc.appendChild(h);

          
          // details price
          var j = document.createElement('span');
          var k = document.createElement('span');
          var priceMoney = Shopify.formatMoney(pPrice, '${{ amount }}');
          var priceMoneyComp = Shopify.formatMoney(pComMax, '${{ amount }}');
          j.setAttribute('class', 'money');
          k.setAttribute('class', 'money');
          j.textContent = priceMoney;
          k.textContent = priceMoneyComp;
          var off = (pComMax - pPrice) / (pComMax / 100);
          if (pCom > pPrice) {
            self.priceNormal.appendChild(j);
            self.priceCompare.appendChild(k);
            self.priceDiscount.textContent = Math.floor(off) + '% off';
          } else {
            self.priceNormal.appendChild(j);
          }

          // details add select and form attribute
          self.variForm.setAttribute('data-action', 'id-' + pId);
          self.variForm.setAttribute('id', 'selectForm');
          var x = document.createElement('select');
          x.setAttribute('name', 'id');
          x.style.display = 'none';
          x.setAttribute('data-select', 'id-' + pId);
          x.setAttribute('id', 'select-' + pId);
          self.select.appendChild(x);

          // create variants
          if (varLen > 1) {
            for(var i = 0; i<varLen; i++) {
              var vari = pVari[i];
              var l = document.createElement('option');
              l.setAttribute('value', vari.id);
              l.textContent = vari.title;
              x.appendChild(l);
            }

            // create swatches
            for (var ii = 0; ii < pOptLen; ii++) {
              var frag = document.createDocumentFragment();
              var isColor = false
              if (/Color|Colour/i.test(pOpt[ii].name)) {
                isColor = true;
              }
              var m = document.createElement('div');
              var n = document.createElement('div');
              var nn = document.createElement('div');
              m.setAttribute('class', 'swatch-qv group');
              if(isColor){
                m.setAttribute('class', 'swatch-qv color-swatch-qv group')
              }
              m.setAttribute('data-option-index', ii);
              n.setAttribute('class', 'swatch-qv-title');
              nn.setAttribute('class', 'swatch-qv-content group');
              n.textContent = pOpt[ii].name;
              m.appendChild(n);

              var optVal = [];
              for (var iii = 0;iii<varLen;iii++) {
                var variant = pVari[iii];
                var val = variant.options[ii];
                var value = val.toLowerCase().replace(/[^a-z0-9\s\-]/g, '').replace(/\s+/g, '-');
                var hex = value.replace(/\-/g, '#')
                var inputId = 'swatch-qv-' + ii + '-' + value;

                if (optVal.indexOf(val) < 0) {
                  var o = document.createElement('div');
                  o.setAttribute('data-value', val);
                  var oClass = 'swatch-qv-element ' + (isColor ? "color" : "") + value + (variant.available ? ' available ' : ' soldout ');
                  o.setAttribute('class', oClass);
                  var q = document.createElement('input');
                  q.setAttribute('id', inputId);
                  q.setAttribute('type', 'radio');
                  q.setAttribute('name', 'option-' + ii);
                  q.setAttribute('value', val);
                  if (iii === 0) { q.setAttribute('checked', '');}
                  if (pOptLen === 1) {
                    if (!variant.available){ q.setAttribute('disabled', 'true');}
                  }
                  o.appendChild(q);
                  var r = document.createElement('label');
                  if (isColor) {
                    r.setAttribute('for', inputId);
                    r.setAttribute('style', 'background-color:' + hex);
                    r.setAttribute('title', hex)
                    o.appendChild(r);
                  } else {
                    r.setAttribute('for', inputId);
                    r.textContent = value;
                    o.appendChild(r);
                  }
                  if (variant.available) {
                    $('#quickView .swatch-qv[data-option-index="' + ii + '"] .' + value).removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
                  }

                  nn.appendChild(o)
                  m.appendChild(nn);
                  frag.appendChild(m);
                  $('#quickView select[name=id]').after(frag)
                  optVal.push(val);
                }
              }
            }
            $('#quickView #selectForm').find(".swatch-qv :radio").change(function() {
              var optIdx = $(this).closest(".swatch-qv").attr("data-option-index");
              var optVal = $(this).val();
              $('#quickView #selectForm').find(".single-option-selector").eq(optIdx).val(optVal).trigger("change");
            });
          } else {
            $('#quickView').find('form#selectForm > select').remove();
            var variant_field = '<input type="hidden" name="id" value="' + pVari[0].id + '">';
            $('#quickView').find('form#selectForm').append(variant_field);

            Currency.convertAll('USD', $('#currencies').val(), 'span.money', 'money_format');
          }
          
          // details stock
          var varii = pVari[0];
          if (varii.available) {
            if (varii.inventory_management !== null) {
              if (varii.inventory_policy === 'continue') {
                self.stock.textContent = varii.inventory_quantity + " in Stock (Allow to Purchase)";
              } else {
                self.stock.textContent = varii.inventory_quantity + " in Stock";
              }
              self.stock.setAttribute('class', 'qv-stock-inv __status-soldout')
            } else {
              self.stock.setAttribute('class', 'qv-stock-inv');
              self.stock.textContent = "";
            }
          } else {
            self.stock.textContent = 'Out of Stock';
            self.stock.setAttribute('class', 'qv-stock-inv __status-soldout')
          }

          // details quantity and total price
          var s = document.createElement('button');
          s.setAttribute('class', 'qv-quantity_decr');
          s.setAttribute('type', 'button');
          s.textContent = '-';
          self.quant.appendChild(s);
          self.quant.style.padding = '4px';
          var t = document.createElement('input');
          t.setAttribute('class', 'qv-quantity_val');
          t.setAttribute('type', 'text');
          t.setAttribute('name', 'quantity');
          t.setAttribute('value', '1');
          self.quant.appendChild(t);
          var u = document.createElement('button');
          u.setAttribute('class', 'qv-quantity_incr');
          u.setAttribute('type', 'button');
          u.textContent = '+';
          self.quant.appendChild(u);

          var quantBut = Array.prototype.slice.call(self.templ.querySelectorAll('.qv-quantity button'));
          quantBut.forEach(function(e,i) {
            e.addEventListener('click', function(ev) {
              ev.preventDefault();
              ev.stopPropagation();
              var qVal = $(".qv-quantity_val").val();
              var n = 1;
              var c = ev.target.getAttribute('class');
              if ( c === 'qv-quantity_incr' ) {
                n = parseInt(qVal, 10) + 1;
              } else if ( qVal > 1 ) {
                n = parseInt(qVal, 10) - 1;
              }
              $("#quickView .qv-quantity_val").val(n);
              self.totalPrice();
            });
          });

          $(self.priceTot).html(Shopify.formatMoney(pPrice, "<span class='money'>${{amount}}</span>"));
          t.addEventListener('change', function(ev) {
            var gelVal = $(ev.target).val();
            if (gelVal > 0) {
              self.totalPrice();
            } else {
              $(ev.target).val(1);
              self.totalPrice();
            }
          });
          Currency.convertAll('USD', $('#currencies').val(), 'span.money', 'money_format');

          // details add to cart , add cart status and more
          self.addCartBut.textContent = 'Add to Cart';
          self.addCartBut.setAttribute('data-opacity', '1');
          if (varLen === 1 && pAvailable === false) {
            self.addCartBut.setAttribute('disabled', 'true')
          }

          self.more.setAttribute('href', pUrl)
          self.more.textContent = 'More Details'

          // Option selectors
          if (varLen > 0) {
            new Shopify.OptionSelectors("select-" + pId, {
              product: prod,
              onVariantSelected: emQuick.prototype.selectVariant
              // enableHistoryState: true
            });
          };
          if (pAvailable && pOptLen > 1) {
              Shopify.optionsMapQ = {};
              Shopify.linkOptionSelectorsQ(prod);
          }

        });
      });
      
      // add to cart queries
      self.addCartBut.addEventListener('click', function(ev) {
        ev.preventDefault();
        ev.stopPropagation();

        var err = document.querySelector('.qv-add-cart_status')
        var variVal = $('#quickView .qv-details_variants select[name=id]').val();
        if (!variVal) {
          variVal = $('#quickView .qv-details_variants input[name=id]').val();
        }
        var quant = $('#quickView .qv-details_variants input[name=quantity]').val();
        if (!quant) {
          quant = 1;
        }
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: { quantity: quant, id: variVal },
          dataType: "json",
          beforeSend: function() {
            ev.target.setAttribute('disabled', 'true');
            console.log('wait add cart...')
          },
          success: function(data) {
            jsGlobal.updateCart();
            ev.target.removeAttribute('disabled');
            console.log('success add cart...')
          },
          error: function(xhr, txt) {
            if(xhr.status === 422) {
              var mes = $.parseJSON(xhr.responseText).description;
              var p = document.createElement('p')
              p.setAttribute('class', 'feedback-warning')
              p.textContent = mes;
              err.appendChild(p);
              setTimeout(function(){
                if (err.hasChildNodes()) {
                  err.removeChild(err.firstChild);
                }
              }, 5000)
            }
            ev.target.removeAttribute('disabled');
            console.log('error add cart...')
          }
        });
      });
    },
    selectVariant: function(variant, selector) {
      var pi = $('#quickView .qv-details_variants');
      var prodPrice = pi.find('.qv-price > .normal');
      var prodCompare = pi.find('.qv-price > .compare');
      var off = document.querySelector('.qv-price .discount');
      if(variant) {

        prodPrice.html(Shopify.formatMoney(variant.price, "<span class=money>${{amount}}</span>"));

        if ( variant.compare_at_price > variant.price ) {
          prodCompare.html(Shopify.formatMoney(variant.compare_at_price, "<span class=money>${{amount}}</span>"));
          prodPrice.html(Shopify.formatMoney(variant.price, "<span class=money>${{amount}}</span>"));
          var offNum = (variant.compare_at_price - variant.price) / (variant.compare_at_price /  100);
          off.textContent = Math.floor(offNum) + "% off"
        } else {
          prodCompare.html("");
          off.textContent = "";
        }

        var form = $('#' + selector.domIdPrefix).closest('form');
        for (var i=0,length=variant.options.length; i<length; i++) {
          var radioButton = form.find('.swatch-qv[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
          if (radioButton.size()) {
            radioButton.get(0).checked = true;
          }
        }

        var invenInfo = document.querySelector('.qv-stock span');
        if (variant.available) {
          if (variant.inventory_management !== null) {
            if (variant.inventory_policy === 'continue') {
              invenInfo.textContent = variant.inventory_quantity + " in Stock (Allow to Purchase)";
            } else {
              invenInfo.textContent = variant.inventory_quantity + " in Stock";
            }
            invenInfo.setAttribute('class', 'qv-stock-inv badge-warning')
          } else {
            invenInfo.setAttribute('class', 'qv-stock-inv')
            invenInfo.textContent = '';
          }
        } else {
          invenInfo.textContent = 'Out of Stock';
          invenInfo.setAttribute('class', 'qv-stock-inv badge-warning')
        }

        var rex = /[\d]{1,3}(\,[\d]{3})?(\.[\d]{2})?/g;
        var norm = document.querySelector('.quick-view .qv-price > .normal');
        var rexMatch = norm.textContent.match(rex)[0];
        if (rexMatch) {
          var round = rexMatch.replace(/[.|,]/g, '');
          var qtVal = $('#quickView .qv-quantity_val').val();
          var q = parseInt(qtVal, 10);
          var tot = round * q;
          var price = Shopify.formatMoney(tot, "<span class='money'>${{amount}}</span>");
          price = price.match(rex);
          var newRex = new RegExp(rexMatch, "g");
          var totEl = $('#quickView .qv-price > .normal').html().replace(newRex, price);
          $('#quickView .qv-price-total').html(totEl);
        }
      }
      if (variant && variant.featured_image) {
        var oriImg = $("#qvImage");
        var newImg = variant.featured_image;
        var elem = oriImg[0];

        Shopify.Image.switchImage(newImg, elem, function(a,b,c) {
          c.setAttribute('src', a)
          var qvImgFeat = document.getElementById('qvImgFeat');
          var $qvImgFeat = $('#qvImgFeat');
          qvImgFeat.setAttribute('data-load', '0');
          $qvImgFeat.waitForImages(function(){
            qvImgFeat.setAttribute('data-load', '1');
          })
          // c.setAttribute('data-magnify-src', a)
          var th = document.querySelectorAll('.qv-images-thumb > li > img');
          var thumb = Array.prototype.slice.call(th);
          thumb.forEach(function(el, idx) {
            el.parentNode.setAttribute('data-selected', '0')
            $('.qv-images-thumb > li[data-pos='+ (b.position) +']').attr('data-selected', '1');
          });
          // if(!toucheDev) {
          //   $("#qvImage").magnify({speed:0});
          // }
        })
      }

      Currency.convertAll('USD', $('#currencies').val(), 'span.money', 'money_format');
    },
    thumbsEvent: function() {
      var self = this;

      var t = document.querySelectorAll('.qv-images-thumb > li > img')
      var tmbs = Array.prototype.slice.call(t);
      tmbs.forEach(function(el, idx) {
        el.addEventListener('click', function(ev) {
          var selected = el.parentNode.getAttribute('data-selected');
          var tar = document.getElementById('qvImage')
          var src = el.parentNode.getAttribute('data-src');
          if (selected === '1') {
            return
          }
          $('.qv-images-thumb > li').attr('data-selected', '0')
          ev.target.parentNode.setAttribute('data-selected', '1')
          tar.setAttribute('src', src)
          var qvImgFeat = document.getElementById('qvImgFeat');
          var $qvImgFeat = $('#qvImgFeat');
          qvImgFeat.setAttribute('data-load', '0');
          $qvImgFeat.waitForImages(function(){
            qvImgFeat.setAttribute('data-load', '1');
          })
          // tar.setAttribute('data-magnify-src', src)
          // if(!self.toucheDev) {
          //   $("#qvImage").magnify({speed:0});
          // }
        })
      })
      self.imgThumb.setAttribute('data-loaded', '1');
    },
    totalPrice: function() {
      var rex = /[\d]{1,3}(\,[\d]{3})?(\.[\d]{2})?/g;
      var norm = document.querySelector('.quick-view .qv-price > .normal');
      var rexMatch = norm.textContent.match(rex)[0];
      if (rexMatch) {
        var round = rexMatch.replace(/[\.|\,]/g, '');
        var qtVal = $('#quickView .qv-quantity_val').val();
        var q = parseInt(qtVal, 10);
        var tot = round * q;
        var price = Shopify.formatMoney(tot, "<span class='money'>${{amount}}</span>");
        price = price.match(rex);
        var newRex = new RegExp(rexMatch, "g");
        var totEl = $('#quickView .qv-price > .normal').html().replace(newRex, price);
        $('#quickView .qv-price-total').html(totEl);
        Currency.convertAll('USD', $('#currencies').val(), 'span.money', 'money_format');
      }
    },
    closeView: function() {
      var self = this;
      self.qvClose.addEventListener('click', function(ev) {
        ev.stopPropagation();
        ev.preventDefault()
        self.closeTasks();
      });
      self.templ.addEventListener('click', function(ev) {
        ev.stopPropagation();
        if (!$(ev.target).is('#qvWrap, #qvWrap *')) {
          self.closeTasks();
        }
      })
      // document.addEventListener('click', function(ev) {
      //   ev.stopPropagation();
      //   // ev.preventDefault()

      //   if (!$(ev.target).is('#qvWrap, #qvWrap *')) {
      //     self.closeTasks();
      //   }
      // })
    },
    closeTasks: function() {
      var self = this;
      self.templ.setAttribute('data-expand', '0');
      self.theBody.setAttribute('data-qvopen', '0');
      self.wrap.setAttribute('data-wait', '1')

      self.imgFeatured.setAttribute('data-load', '0')
      while (self.imgFeatured.firstChild) {
        self.imgFeatured.removeChild(self.imgFeatured.firstChild);
      }
      self.imgThumb.setAttribute('data-loaded', '0');
      while (self.imgThumb.firstChild) {
        self.imgThumb.removeChild(self.imgThumb.firstChild);
      }
      while (self.title.firstChild) {
        self.title.removeChild(self.title.firstChild);
      }
      while (self.vendor.firstChild) {
        self.vendor.removeChild(self.vendor.firstChild);
      }
      // self.desc.removeChild(self.desc.firstChild);
      while (self.priceNormal.firstChild) {
        self.priceNormal.removeChild(self.priceNormal.firstChild);
      }
      if (self.priceCompare.hasChildNodes()) {
        self.priceCompare.removeChild(self.priceCompare.firstChild);
        self.priceDiscount.textContent = "";
      }
      self.variForm.removeAttribute('data-action');
      self.variForm.removeAttribute('id');
      while(self.select.firstChild){
        self.select.removeChild(self.select.firstChild)
      }
      var stocks = self.variForm.querySelector('.qv-stock > span');
      stocks.textContent = '';
      stocks.setAttribute('class', 'qv-stock-inv');
      self.quant.removeAttribute('style')
      while(self.quant.firstChild){
         self.quant.removeChild(self.quant.firstChild);
      }
      while (self.priceTot.firstChild) {
        self.priceTot.removeChild(self.priceTot.firstChild);
      }
      self.addCartBut.textContent = "";
      self.addCartBut.setAttribute('data-opacity', '0');
      self.addCartBut.removeAttribute('disabled')
      self.addCartStatus.textContent = "";
      self.more.removeAttribute('href');
      self.more.textContent = "";
      var noVari = self.variForm.querySelector('input[name=id');
      if(noVari) {
        self.variForm.removeChild(noVari);
      }
    }
  }
  window.emQuick = emQuick;

})(jQuery, window);